/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, ElementRef } from "@angular/core";
import { DatagridRenderOrganizer } from "./render-organizer";
import { DomAdapter } from "./dom-adapter";
var DatagridBodyRenderer = (function () {
    function DatagridBodyRenderer(el, organizer, domAdapter) {
        var _this = this;
        this.el = el;
        this.organizer = organizer;
        this.domAdapter = domAdapter;
        this.subscription = organizer.scrollbar.subscribe(function () { return _this.computeScrollbarWidth(); });
    }
    DatagridBodyRenderer.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    DatagridBodyRenderer.prototype.computeScrollbarWidth = function () {
        this.organizer.scrollbarWidth.next(this.domAdapter.scrollBarWidth(this.el.nativeElement));
    };
    return DatagridBodyRenderer;
}());
export { DatagridBodyRenderer };
DatagridBodyRenderer.decorators = [
    { type: Directive, args: [{
                selector: "[clrDgBody]"
            },] },
];
/** @nocollapse */
DatagridBodyRenderer.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: DatagridRenderOrganizer, },
    { type: DomAdapter, },
]; };
//# sourceMappingURL=body-renderer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/render/body-renderer.js
// module id = 290
// module chunks = 4